import { AuthProvider, useAuth } from '@hypeit-gmbh/hypeit-ui-core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { MantineProvider } from './MantineProvider';
import { routeTree } from './routeTree.gen';
import { SnackbarProvider } from './SnackbarProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      retry: 1,
      staleTime: 1000 * 60 * 10, // 10 minutes
    },
  },
});

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  notFoundMode: 'root',
  scrollRestoration: true,
});

// 💡 Register for router typesafety
declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}

export const AppProvider: React.FC = () => {
  const authMethods = useAuth();

  return (
    <AuthProvider {...authMethods}>
      <MantineProvider>
        <SnackbarProvider />
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools buttonPosition="bottom-left" />
          <RouterProvider router={router} />
        </QueryClientProvider>
      </MantineProvider>
    </AuthProvider>
  );
};
